import { render } from "./GoogleTwoFactorVerify.vue?vue&type=template&id=65739908"
import script from "./GoogleTwoFactorVerify.vue?vue&type=script&lang=js"
export * from "./GoogleTwoFactorVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__